import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchArticleTitles = async (topic, writerStyle, articleType, articleGenre) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-article-titles`,
      { topic, writerStyle, articleType, articleGenre },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching article titles:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania tytułów. Spróbuj ponownie później.'
    );
  }
};

export const fetchArticleContent = async (title, topic, writerStyle, articleType, articleGenre) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-article-content`,
      { title, topic, writerStyle, articleType, articleGenre },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching article content:', error.message);
    throw new Error(
      'Przeciążenie sieci. Spróbuj ponownie za kilka minut.'
    );
  }
};